import { createTheme } from '@mui/material/styles';

const myTheme = createTheme({
  palette: {
    primary: { main: '#1a3c5e' },
    secondary: { main: '#1a3c5e' },
    background: { default: '#f5f7fa' },
  },
  typography: {
    fontFamily: "'Roboto', 'Segoe UI', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none', fontWeight: 600 },
      },
    },
  },
});

export default myTheme;
